import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function Accelerator() {
  const rows = [{
    sit: 'Tenés los PDFs pero no sabés por dónde empezar',
    sin: 'Parálisis. Los guardás sin usar.',
    con: 'Día 1 al 30 exactamente definidos.'
  }, {
    sit: 'Querés subir precios pero lo postergás',
    sin: 'Sigue igual el mes que viene',
    con: 'Día 5: precio calculado y publicado'
  }, {
    sit: 'No sabés cómo conectar los tomos entre sí',
    sin: 'Cada PDF parece un mundo aparte',
    con: 'El mapa muestra cómo todo encaja'
  }, {
    sit: 'Querés medir si funcionó',
    sin: 'No tenés con qué comparar',
    con: 'Auditoría Día 0 vs Día 30 con números reales'
  }];
  return <section className="py-16 px-4 bg-dark-card/30" data-id="element-46">
      <div className="max-w-4xl mx-auto" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-49">
            🚀 ¿QUÉ AGREGA EL ACELERADOR "RUTA CRÍTICA 30 DÍAS"?
          </h2>
          <p className="text-xl text-gray-400" data-id="element-50">
            El Acelerador es el mapa que convierte 480 páginas en 30 acciones
            concretas. Un día, una acción. Sin abrumarse.
          </p>
        </div>

        <div className="overflow-x-auto" data-id="element-51">
          <table className="w-full text-left border-collapse" data-id="element-52">
            <thead data-id="element-53">
              <tr className="border-b border-dark-border" data-id="element-54">
                <th className="p-4 text-gray-400 font-medium" data-id="element-55">Situación</th>
                <th className="p-4 text-red-400 font-bold bg-red-500/5 rounded-tl-xl" data-id="element-56">
                  ❌ Sin Acelerador
                </th>
                <th className="p-4 text-brand font-bold bg-brand/5 rounded-tr-xl" data-id="element-57">
                  ✅ Con Acelerador
                </th>
              </tr>
            </thead>
            <tbody data-id="element-58">
              {rows.map((row, i) => <motion.tr key={i} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="border-b border-dark-border/50" data-id="element-59">
                  <td className="p-4 text-white font-medium" data-id="element-60">{row.sit}</td>
                  <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-61">{row.sin}</td>
                  <td className="p-4 text-white font-bold bg-brand/5" data-id="element-62">
                    {row.con}
                  </td>
                </motion.tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}